<script lang="ts">
  import { getStr, globalCurrencyTag } from '../../../common/util';
  import Icon from '../../common/components/Icon.svelte';
  import Text from '../../common/components/Text.svelte';
  import { filterOutPromotions } from '../services/pdp-data-services';
  import { productDetails } from '../store/pdp_store';

  $productDetails = window['ACC'].config.productDetails;

  $: potentialPromotions = $productDetails.potentialPromotions;
  $: name = $productDetails.name;
  $: productUrl = `/cart/${$productDetails.code}`;
  $: potentialPromotionsFiltered = filterOutPromotions(potentialPromotions);

  const currency = globalCurrencyTag;
</script>

{#if potentialPromotionsFiltered?.length}
  {@const editQuantity = [false]}
  {@const isAlternativeSpecialOffer = [false]}
  {@const isSelectTarget = [false]}

  {#each potentialPromotionsFiltered as promotion, i}
    <!-- need to implement null condition block -->
    {#if !promotion.excludeFromStorefrontDisplay}
      <section class="offers-wrapper">
        <div class="wrapper">
          {#if promotion.messageType !== '' && promotion.messageType !== null}
            <!-- Header start -->
            {#if i == 0}
              {#if productDetails?.hasFreeGift && productDetails?.specialOfferDataList.length === 0}
                <div class="offer-title">
                  <Text key="extra.pdp.promotion.alternative.special.offer" />
                </div>
              {:else}
                <div class="offers-title">
                  <Text key="product.promotion.specialOffer" />
                </div>
              {/if}
            {/if}
            <!-- Header End -->
            <!-- offers start -->
            <div class="offer-wrapper">
              <!-- <Icon type="png" glyph="offer" mobileSize={32} desktopSize={47} /> -->
              <Icon type="url" desktopSize={47} mobileSize={32} glyph={getStr('extra.promotion.icon.url')} />
              <div class="offer">
                <div class="offer-description">
                  <!--  promotion.messageType eq 'BUYNOFXFORZPERCOFF' || promotion.messageType eq 'BUYNOFXFORZAMOUNTOFF' Start-->
                  {#if promotion.messageType === 'BUYNOFXFORZPERCOFF' || promotion.messageType === 'BUYNOFXFORZAMOUNTOFF'}
                    {#if promotion.absolute}
                      {#if promotion.qtyThresholdType}
                        {#if promotion.discountLimit !== null && promotion.discountLimit > 0}
                          {#if promotion.multipleBuyListItems}
                            <Text
                              key="extra.pdp.promotion.buy.nofx.forzamountoff.discountLimit.multipleBuyList"
                              args={[
                                promotion.saveAmount.value,
                                currency,
                                `${productUrl} / ${promotion.targetProductPromotion}`,
                              ]}
                            />
                          {:else}
                            <Text
                              key="extra.pdp.promotion.buy.nofx.forzamountoff.discountLimit"
                              args={[promotion.saveAmount.value, currency, name]}
                            />
                            {(editQuantity[0] = true) ? '' : ''}
                          {/if}
                        {:else if promotion.referenceType === 'all'}
                          <Text
                            key="extra.pdp.promotion.buy.nofx.forzamountoff.qtyThresholdType"
                            args={[promotion.referenceTypeLocalized, promotion.saveAmount.value, currency]}
                          />
                        {:else}
                          <Text
                            key="extra.pdp.promotion.buy.nofx.forzamountoff.qtyThresholdType"
                            args={[
                              promotion.referenceTypeLocalized,
                              promotion.sourceRefQty,
                              promotion.saveAmount.value,
                              currency,
                            ]}
                          />
                        {/if}
                      {:else}
                        <Text
                          key="extra.pdp.promotion.buy.nofx.forzamount"
                          args={[promotion.quantity, name, promotion.saveAmount.value, currency]}
                        />
                        {(editQuantity[0] = true) ? '' : ''}
                      {/if}
                    {:else if promotion.qtyThresholdType}
                      {#if promotion.discountLimit !== null && promotion.discountLimit > 0}
                        {#if promotion.multipleBuyListItems}
                          <Text
                            key="extra.pdp.promotion.buy.nofx.forzpercentage.discountLimit.multipleBuyList"
                            args={[promotion.saveAmount.value, productUrl, promotion.targetProductPromotion]}
                          />
                        {:else}
                          <Text
                            key="extra.pdp.promotion.buy.nofx.forzpercentage.discountLimit"
                            args={[promotion.saveAmount.value, name]}
                          />
                        {/if}
                      {:else if promotion.referenceType === 'all'}
                        <Text
                          key="extra.pdp.promotion.buy.nofx.forzpercentage.qtyThresholdType"
                          args={[promotion.referenceTypeLocalized, promotion.saveAmount.value]}
                        />
                      {:else}
                        <Text
                          key="extra.pdp.promotion.buy.nofx.forzpercentage.qtyThresholdType"
                          args={[promotion.referenceTypeLocalized, promotion.sourceRefQty, promotion.saveAmount.value]}
                        />
                        {(editQuantity[0] = true) ? '' : ''}
                      {/if}
                    {:else}
                      <Text
                        key="extra.pdp.promotion.buy.nofx.forzpercentage"
                        args={[promotion.quantity, name, promotion.saveAmount.value]}
                      />
                      {(editQuantity[0] = true) ? '' : ''}
                    {/if}
                  {/if}
                  <!--  promotion.messageType eq 'BUYNOFXFORZPERCOFF' || promotion.messageType eq 'BUYNOFXFORZAMOUNTOFF' End-->
                  {#if promotion.messageType === 'BUYNOFXFORZAMOUNT'}
                    {#if promotion.absolute}
                      {#if promotion.prorateFixedPrice}
                        <Text
                          key="extra.pdp.promotion.buy.nofx.forzamount.proratefixedprice"
                          args={[
                            promotion.referenceTypeLocalized,
                            promotion.sourceRefQty,
                            promotion.saveAmount.value,
                            currency,
                          ]}
                        />
                        {(isSelectTarget[0] = true) ? '' : ''}
                      {:else if promotion.fixedPrice}
                        <Text
                          key="extra.pdp.promotion.buy.nofx.forzamount.fixedprice"
                          args={[promotion.quantity, name, promotion.saveAmount.value, currency]}
                        />
                        {(editQuantity[0] = true) ? '' : ''}
                      {:else}
                        <Text
                          key="extra.pdp.promotion.buy.nofx.forzamount"
                          args={[promotion.quantity, name, promotion.saveAmount.value, currency]}
                        />
                        {(editQuantity[0] = true) ? '' : ''}
                      {/if}
                    {/if}
                  {/if}

                  {#if promotion.messageType === 'BUYAMOUNTNOFXFORZPERCOFF' || promotion.messageType === 'BUYAMOUNTNOFXFORZAMOUNTOFF'}
                    {#if promotion.absolute}
                      <Text
                        key="extra.pdp.promotion.buy.amount.nofx.forzamount"
                        args={[
                          promotion.referenceTypeLocalized,
                          promotion.amountThreshold.value,
                          currency,
                          promotion.saveAmount.value,
                        ]}
                      />
                    {:else}
                      <Text
                        key="extra.pdp.promotion.buy.amount.nofx.forzpercentage"
                        args={[
                          promotion.referenceTypeLocalized,
                          promotion.amountThreshold.value,
                          currency,
                          promotion.saveAmount.value,
                        ]}
                      />
                    {/if}
                    {(isSelectTarget[0] = true) ? '' : ''}
                  {/if}

                  {#if promotion.messageType === 'BUYNORMOREOFXFORZAMOUNTEACH' || promotion.messageType === 'BUYNORMOREOFXFORZPERCOFF'}
                    {#if promotion.absolute}
                      <Text
                        key="extra.pdp.promotion.buy.normoreofx.forzamount.each"
                        args={[promotion.quantity, name, promotion.saveAmount.value, currency]}
                      />
                    {:else}
                      <Text
                        key="extra.pdp.promotion.buy.normoreofx.forzpercentage"
                        args={[promotion.quantity, name, promotion.saveAmount.value]}
                      />
                    {/if}
                    {(editQuantity[0] = true) ? '' : ''}
                  {/if}

                  {#if promotion.messageType === 'BUYNOFXGETYATZAMOUNTOFF'}
                    <Text
                      key="extra.pdp.promotion.buy.nofx.get.yat.zamountoff.each.message"
                      args={[promotion.quantity, name, promotion.saveAmount.value, currency]}
                    />
                    {(isSelectTarget[0] = true) ? '' : ''}
                  {/if}

                  {#if promotion.messageType === 'BUYNOFXGETYATZAMOUNT'}
                    <Text
                      key="extra.pdp.promotion.buy.nofx.get.yat.zamount.each.message"
                      args={[promotion.quantity, name, promotion.saveAmount.value, currency]}
                    />
                    {(isSelectTarget[0] = true) ? '' : ''}
                  {/if}

                  {#if promotion.messageType === 'BUYAMOUNTNORMOREOFXGETYATZAMOUNTOFF'}
                    <Text
                      key={`extra.pdp.promotion.buy.amount.normoreofx.get.yat.zamountoff.each.message.${promotion.referenceType}`}
                      args={[
                        promotion.amountThreshold.value,
                        currency,
                        promotion.referenceTypeLocalized,
                        promotion.saveAmount.value,
                      ]}
                    />
                    {(isSelectTarget[0] = true) ? '' : ''}
                  {/if}

                  {#if promotion.messageType === 'BUYAMOUNTNORMOREOFXGETYATZAMOUNT'}
                    <Text
                      key={`extra.pdp.promotion.buy.amount.normoreofx.get.yat.zamount.each.message.${promotion.referenceType}`}
                      args={[
                        promotion.amountThreshold.value,
                        currency,
                        promotion.referenceTypeLocalized,
                        promotion.saveAmount.value,
                      ]}
                    />
                    {(isSelectTarget[0] = true) ? '' : ''}
                  {/if}

                  {#if promotion.messageType === 'BUYAMOUNTNORMOREOFXGETYATZPERCOFF'}
                    <Text
                      key={`extra.pdp.promotion.buy.amount.normoreofx.get.yat.zpercentageoff.each.message.${promotion.referenceType}`}
                      args={[
                        promotion.amountThreshold.value,
                        currency,
                        promotion.referenceTypeLocalized,
                        promotion.saveAmount.value,
                      ]}
                    />
                    {(isSelectTarget[0] = true) ? '' : ''}
                  {/if}

                  {#if promotion.messageType === 'BUYNOFXGETLOWESTPRICEDXATZPERCOFF'}
                    {#if promotion.amountThreshold !== '' && promotion.amountThreshold !== null && promotion.amountThreshold.value > 0}
                      <Text
                        key="extra.pdp.promotion.buy.threshold.nofx.get.lowest.zpercentageoff.message"
                        args={[promotion.amountThreshold.value, currency, promotion.saveAmount.value]}
                      />
                    {:else if promotion.promotionOnRewardItems}
                      {#if !promotion.absolute}
                        <Text
                          key="extra.pdp.promotion.buy.threshold.nofx.get.lowest.zpercentageoff.onrewarditems.percentage.message"
                          args={[promotion.referenceTypeLocalized, promotion.saveAmount.value]}
                        />
                      {:else if promotion.absolute && promotion.fixedPrice}
                        <Text
                          key="extra.pdp.promotion.buy.threshold.nofx.get.lowest.zpercentageoff.onrewarditems.fixedprice.message"
                          args={[promotion.referenceTypeLocalized, promotion.saveAmount.value, currency]}
                        />
                      {:else}
                        <Text
                          key="extra.pdp.promotion.buy.threshold.nofx.get.lowest.zpercentageoff.onrewarditems.fixeddiscount.message"
                          args={[promotion.referenceTypeLocalized, promotion.saveAmount.value, currency]}
                        />
                      {/if}
                    {:else}
                      <Text
                        key="extra.pdp.promotion.buy.amount.nofx.get.lowest.zpercentageoff.each.message"
                        args={[promotion.sourceRefQty, promotion.saveAmount.value]}
                      />
                    {/if}
                    {(isSelectTarget[0] = true) ? '' : ''}
                  {/if}

                  {#if promotion.messageType === 'BUYNOFXGETYATZPERCOFF'}
                    {#if promotion.buyMoreSaveMorePromo}
                      <Text
                        key="extra.pdp.promotion.buy.more.save.more.each.message"
                        args={[name, promotion.sourceRefQty, promotion.saveAmount.value]}
                      />
                    {:else}
                      <Text
                        key="extra.pdp.promotion.buy.nofx.get.yat.zpercentageoff.each.message"
                        args={[promotion.quantity, name, promotion.saveAmount.value, promotion.sourceRefQty]}
                      />
                    {/if}
                    {(isSelectTarget[0] = true) ? '' : ''}
                  {/if}
                </div>
                <!-- new added -->
                {#if isSelectTarget[0]}
                  <div class="offer-sub-des">
                    <Text key="extra.pdp.promotion.selected.list.cart" />
                    {#if isAlternativeSpecialOffer[0]}
                      <Text key="extra.pdp.alternative.remove.offer.message" />
                    {/if}
                  </div>
                  {(isSelectTarget[0] = false) ? '' : ''}
                {/if}
                {#if editQuantity[0]}
                  <div class="offer-sub-des">
                    {#if promotion.qtyThresholdType}
                      <Text key="extra.pdp.promotion.edit.quantity.add.items.text" />
                    {:else}
                      <Text key="extra.pdp.promotion.edit.quantity.text" />
                    {/if}
                    {#if isAlternativeSpecialOffer[0]}
                      <Text key="extra.pdp.alternative.remove.offer.message" />
                    {/if}
                  </div>
                  {(editQuantity[0] = false) ? '' : ''}
                {/if}
                {#if promotion.discountLimit !== null && promotion.discountLimit > 0}
                  <div class="offer-sub-des">
                    {#if promotion.multipleBuyListItems}
                      <Text
                        key="extra.pdp.promotion.discountLimit.multipleBuyList.info"
                        args={[promotion.discountLimit]}
                      />
                    {:else}
                      <Text
                        key="extra.pdp.promotion.discountLimit.info"
                        args={[promotion.discountLimit, productDetails.name]}
                      />
                    {/if}
                  </div>
                {/if}
                <!-- new added  -->
              </div>
            </div>
            <!-- offers end -->
          {/if}
        </div>
      </section>
    {/if}
  {/each}
{/if}

<style lang="scss">
  @import '../../common/styles/colors.new.scss';

  .offers-wrapper {
    display: grid;
    grid-template-columns: 1fr;
    grid-auto-rows: minmax(0, auto);
    background-color: $primary-white;
    @include desktop-min-width {
      max-width: 1440px;
    }

    .offers-title {
      color: $neutral-dark-01;
      font-weight: 700;
      font-size: 22px;
      line-height: 24px;
      margin-bottom: 24px;
      @include desktop-min-width {
        font-size: 36px;
        line-height: 40px;
        margin-bottom: 32px;
      }
    }

    .offer-wrapper {
      display: flex;
      gap: 26px;
      background: $neutral-light-04;
      padding: 35px 22px 37px;
      border-radius: 20px;
      @include desktop-max-width {
        gap: 16px;
        padding: 24px 8px;
      }
    }

    .offer-wrapper:not(:last-child) {
      margin-bottom: 20px;
      @include desktop-max-width {
        margin-bottom: 16px;
      }
    }

    .offer-description {
      font-weight: 500;
      font-size: 24px;
      line-height: 26px;
      color: $neutral-dark-01;
      margin-bottom: 2px;
      @include desktop-max-width {
        font-size: 20px;
        line-height: 22px;
      }
    }

    .offer-sub-des {
      color: $neutral-dark-02;
      font-size: 20px;
      line-height: 24px;
      font-weight: 400;
      @include desktop-max-width {
        font-size: 16px;
        line-height: 18px;
      }
    }
  }
</style>
